import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FONTS } from 'styles/theme/fonts';
import { COLORS } from 'styles/theme/colors';
import { Z_INDEX } from 'enums/form-enums';

export const TextInput = ({
  placeholder,
  type,
  onChange,
  hasValue,
  hasError,
  handleClick,
  handleFocus,
  isHidden,
  zIndex,
  errorColor,
}) => {
  return (
    <>
      <TextInput.StyledInput
        hasError={hasError}
        errorColor={errorColor}
        hasValue={hasValue}
        placeholder={placeholder}
        type={isHidden ? type : 'text'}
        onChange={onChange}
        onFocus={handleFocus}
        zIndex={zIndex}
      />
      {type === 'password' && <TextInput.ShowHide isHidden={isHidden} onClick={handleClick} />}
    </>
  );
};

TextInput.StyledInput = styled.input`
  border: ${(props) =>
    props.hasError
      ? `1px solid ${props.errorColor || COLORS.primaryInputErrorBorder}`
      : `1.4px solid ${COLORS.textInputBorder}`};
  background: ${COLORS.primaryBackground};
  height: 51px;
  max-width: 285px;
  width: 285px;
  font-size: 16px;
  font-family: ${FONTS.default};
  color: ${(props) =>
    props.hasError ? props.errorColor || COLORS.primaryErrorText : COLORS.secondaryText};
  font-size: 16px;
  line-height: 19px;
  padding: ${(props) => (props.hasValue ? '20px 0 9px 24px' : '20px 0px 17px 24px')};

  &:focus,
  &:hover {
    color: #898989;
    border: 1px solid
      ${(props) =>
        props.hasError
          ? props.errorColor || COLORS.primaryInputErrorBorder
          : COLORS.secondaryBorder};
    outline: none;
    z-index: ${(props) => props.zIndex || 0};
  }

  &:focus {
    color: ${COLORS.primaryText};
  }
`;

TextInput.ShowHide = styled.button`
  border: none;
  background-color: ${COLORS.secondaryBackground};
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url('/assets/svg/${(props) => (props.isHidden ? `hide` : `show`)}.svg') ;
  height: 10px;
  width: 10px;
  position: absolute;
  right: 16px;
  top: 22px;
  z-index: ${Z_INDEX.INPUT};

  &:focus {
    outline: none;
  }
`;

TextInput.propTypes = {
  placeholder: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func,
  hasValue: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  hasError: PropTypes.bool,
  handleClick: PropTypes.func,
  handleFocus: PropTypes.func,
  isHidden: PropTypes.bool,
  zIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  errorColor: PropTypes.string,
};

export default TextInput;
